<template>
  <div class="flex" style="flex-direction:row;">
    <div
      class="search-full-container w-full h-full absolute right-0 top-0"
      :class="{'flex': showFullSearch}"
      style="align-self:flex-end"
      v-show="showFullSearch"
    >
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="navbarSearchAndPinList"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Explore Vuexy..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false"
      >
        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:pages="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>

        <!-- No Items Slot -->
        <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <div>{{group_name}}</div>
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>
      </vx-auto-suggest>

      <div class="absolute right-0 h-full z-50">
        <vs-icon
          icon="close"
          @click="showFullSearch = false"
          class="cursor-pointer navbar-fuzzy-search close-search-icon mr-4"
        ></vs-icon>
      </div>
    </div>
    <vs-icon
      style="position:absolute; right:70px; top:20px;"
      icon="search"
      @click="showFullSearch = true"
      class="cursor-pointer navbar-fuzzy-search mr-4"
    ></vs-icon>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";

export default {
  components: {
    VxAutoSuggest
  },
  data() {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      showFullSearch: false,
      handler: null,
      suggestion: []
    };
  },

  mounted() {},
  created() {
    this.handler = function(e) {
      //console.log(e.key);
      //console.log(this.$store.state.navbarSearchAndPinList);
      //this.showFullSearch = true;
    };
    window.addEventListener("keydown", this.handler);
  },
  methods: {
    selected(item) {
      item.pages ? this.$router.push(item.pages.url).catch(() => {}) : null;
      this.showFullSearch = false;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    }
  }
};
</script>
<style>
.navbar-fuzzy-search,
.close-search-icon {
  font-size: 2rem;
}

.close-search-icon {
  margin-top: 20px;
}
</style>
